import { RecommendationPayload, RecommendationResponse } from '../../types/common';
import { Product } from '../../types/product.types';
import { PRODUCT_PAGE_SIZE } from '../../utils/constants';
import { getRecommendationPieceResult } from '../../utils/helper';
import ProductService from '../product/product.service';
import RecommendationServices from '../recommendation/recommendations.service';

export async function brandAndCategoryRecommendationProducts(
  payload: RecommendationPayload,
  assignRecommendationData?: (rProducts: RecommendationResponse) => void,
  mmid?: string,
): Promise<RecommendationResponse> {
  try {
    const data = await RecommendationServices.getBrandAndCategoryRecommendationProducts(
      {
        productId: payload?.productId || '',
        storeCodes: payload?.recommendationStoreCodes ?? payload?.storeCodes,
        size: PRODUCT_PAGE_SIZE,
        page: payload.page,
        type: payload.type,
        ...(payload?.isExpressMode && {
          expressDelivery: payload?.isExpressMode,
        }),
      },
      payload?.accessToken || '',
    );

    const productIds = data?.recommendations?.map((x) => x.productId);

    if (!productIds || productIds?.length === 0) {
      // Return mock data for testing
      return {
        products: [],
        recommendationType: '',
        totalCount: 0,
        actualCount: 0,
        personalised: false,
      };
    }

    assignRecommendationData?.({
      products: productIds.map((id) => ({ id: `makro_${id}` })) as any,
      recommendationType: '',
      totalCount: data.total ?? 0,
      actualCount: productIds?.length,
      personalised: data?.personalised,
    });

    const productsData = await ProductService.getProductsByIdsV2(
      productIds,
      payload.storeCodes ?? [],
      payload?.isExpressMode,
      payload?.isSameDay,
      undefined,
      undefined,
      payload?.countryCode as any,
      undefined,
      mmid,
      payload?.afcStoreCodes,
      payload?.isAfcStoreEnabled,
      payload?.userSegments,
      payload?.isHorecaMemberEnabled,
    );

    const recommendProducts = getRecommendationPieceResult(
      productIds,
      productsData as Product[],
      payload.recommendationStoreCodes ?? payload.storeCodes ?? [],
      data.recommendations,
      payload?.hasAlcoholProductAvailability,
    ) as Product[];

    return {
      products: recommendProducts || [],
      recommendationType: '',
      totalCount: data.total ?? 0,
      actualCount: productIds?.length,
      personalised: data?.personalised,
    };
  } catch {
    // Return mock data when API fails
    return {
      products: [],
      recommendationType: '',
      totalCount: 0,
      actualCount: 0,
      personalised: false,
    };
  }
}
